<template>
  <d2-container>
    <template slot="header">
      <el-select v-model="query.ownerType" clearable size="small" placeholder="归属类型" style="width: 150px; margin-right: 8px">
        <el-option label="个人" value="PERSONAL"></el-option>
        <el-option label="组织" value="ORGANIZATION"></el-option>
      </el-select>
      <el-input v-model="query.ownerId" clearable size="small" placeholder="归属ID" style="width: 180px; margin-right: 8px" @keyup.enter.native="load"></el-input>
      <el-button type="primary" size="small" icon="el-icon-search" @click="load">搜索</el-button>
      <el-button type="success" size="small" icon="el-icon-plus" @click="openGrant">人工发放</el-button>
    </template>

    <el-table size="small" stripe border :data="records" v-loading="loading">
      <el-table-column prop="id" label="ID" width="150"></el-table-column>
      <el-table-column label="归属类型" width="130">
        <template slot-scope="scope">{{ ownerTypeLabel(scope.row.ownerType) }}</template>
      </el-table-column>
      <el-table-column prop="ownerId" label="归属ID" width="150"></el-table-column>
      <el-table-column prop="availableAmount" label="可用无限积分" width="130" align="right"></el-table-column>
      <el-table-column prop="reservedAmount" label="冻结无限积分" width="130" align="right"></el-table-column>
      <el-table-column prop="consumedAmount" label="已消费无限积分" width="140" align="right"></el-table-column>
      <el-table-column prop="expiredAmount" label="已过期无限积分" width="140" align="right"></el-table-column>
      <el-table-column prop="totalGrantedAmount" label="累计入账无限积分" width="150" align="right"></el-table-column>
      <el-table-column prop="updateTime" label="更新时间" min-width="170"></el-table-column>
    </el-table>

    <template slot="footer">
      <el-pagination
        :current-page.sync="query.currentPage"
        :page-size="query.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSize"
        @current-change="handlePage"
      ></el-pagination>
    </template>

    <el-dialog title="人工发放无限积分" :visible.sync="grantDialog" width="620px">
      <el-form :model="grantForm" label-width="120px">
        <el-form-item label="归属对象" required>
          <owner-selector
            v-model="grantForm.ownerId"
            :owner-type.sync="grantForm.ownerType"
            size="small"
          ></owner-selector>
        </el-form-item>
        <el-form-item label="无限积分数量" required>
          <el-input-number v-model="grantForm.amount" :min="0.0001" :precision="4" :step="10" style="width: 100%"></el-input-number>
        </el-form-item>
        <el-form-item label="有效天数">
          <el-input-number v-model="grantForm.validityDays" :min="0" :step="1" style="width: 100%"></el-input-number>
        </el-form-item>
        <el-form-item label="标题">
          <el-input v-model="grantForm.title"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="grantForm.remark" type="textarea" :rows="3"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="grantDialog = false">取消</el-button>
        <el-button type="primary" @click="submitGrant">确认发放</el-button>
      </span>
    </el-dialog>
  </d2-container>
</template>

<script>
import { getAiPointAccounts, grantAiPoint } from '@/api/ai/rights'
import OwnerSelector from '@/components/ai-rights/OwnerSelector.vue'
import { ownerTypeLabel } from './labels'

export default {
  name: 'aiPointAccountManager',
  components: {
    OwnerSelector
  },
  data () {
    return {
      query: { currentPage: 1, pageSize: 20, ownerType: '', ownerId: '' },
      records: [],
      total: 0,
      loading: false,
      grantDialog: false,
      grantForm: this.defaultGrant()
    }
  },
  created () {
    this.load()
  },
  methods: {
    defaultGrant () {
      return { ownerType: 'PERSONAL', ownerId: '', amount: 100, validityDays: 30, title: '后台人工发放无限积分', remark: '' }
    },
    load () {
      this.loading = true
      getAiPointAccounts(this.query).then(res => {
        this.records = (res && res.records) || []
        this.total = Number((res && res.total) || 0)
      }).finally(() => {
        this.loading = false
      })
    },
    handleSize (size) {
      this.query.pageSize = size
      this.load()
    },
    handlePage (page) {
      this.query.currentPage = page
      this.load()
    },
    ownerTypeLabel,
    openGrant () {
      this.grantForm = this.defaultGrant()
      this.grantDialog = true
    },
    submitGrant () {
      grantAiPoint(this.grantForm).then(() => {
        this.$message.success('发放成功')
        this.grantDialog = false
        this.load()
      })
    }
  }
}
</script>
